import React from 'react';
import logo from '../assets/voip2-logo-navy.png';

/**
 * VOIP2's letterhead above an agreement on screen: the logo and the company details.
 * `info` is the `letterhead` the agreement APIs return (backend services/company_info.py, the one place these
 * details live), so nothing here is typed in twice. Renders nothing until the details are there.
 * `compact` is the smaller version for the agreement panels in signing forms (website signup, portal).
 */
const AgreementLetterhead = ({ info, compact = false }) => {
  if (!info) return null;
  const small = compact ? 'text-[10.5px]' : 'text-[11px] sm:text-xs';
  return (
    <div className="agreement-letterhead mb-5 font-sans not-italic" data-testid="agreement-letterhead">
      <div className="flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between sm:gap-3">
        <img src={logo} alt="VOIP2" width="360" height="101" className={compact ? 'h-6 w-auto self-start' : 'h-8 w-auto self-start sm:h-9'} />
        <div className={`${small} leading-snug text-gray-600 sm:text-right`}>
          <p className="!mt-0 font-semibold text-[#0a1f2e]">{info.name}</p>
          <p className="!mt-0">Registered in {info.jurisdiction}, company no. {info.company_number}</p>
          <p className="!mt-0">Registered office: {info.registered_office}</p>
          <p className="!mt-0">Trading address: {info.trading_address}</p>
          <p className="!mt-0">
            <a href={`mailto:${info.email}`} className="text-[#0a1f2e] underline-offset-2 hover:underline">{info.email}</a>
            {' · '}{info.phone}{' · '}{info.website}
          </p>
          <p className="!mt-0">ICO registration {info.ico} · Ofcom RID {info.ofcom_rid}</p>
        </div>
      </div>
      <div className="mt-3 flex h-[2px]" aria-hidden="true">
        <span className="w-16 bg-[#c8ff00]" />
        <span className="flex-1 bg-gray-200" />
      </div>
    </div>
  );
};

export default AgreementLetterhead;
